import React from "react";
import { useTranslation } from "react-i18next";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import PageHero from "@/components/site/PageHero";
import useReveal from "@/hooks/useReveal";
import { PRIVACY_POLICY_EN, PRIVACY_POLICY_VI } from "@/data/legalContent";
import { TERMS_OF_USE_EN, TERMS_OF_USE_VI } from "@/data/legalContentTerms";

function renderBlock(b, i) {
  if (b.type === "h2") {
    return (
      <h2
        key={i}
        style={{ fontSize: "clamp(1.375rem, 2vw, 1.75rem)", fontWeight: 500, lineHeight: 1.3 }}
        className="mt-14 mb-4 font-display text-[#14355a] tracking-tight"
      >
        {b.text}
      </h2>
    );
  }
  if (b.type === "h3") {
    return (
      <h3
        key={i}
        style={{ fontSize: "clamp(1.05rem, 1.4vw, 1.25rem)", fontWeight: 500 }}
        className="mt-8 mb-3 font-display text-[#14355a] tracking-tight"
      >
        {b.text}
      </h3>
    );
  }
  if (b.type === "ul") {
    return (
      <ul key={i} className="mt-3 mb-4 space-y-2 pl-5 list-disc marker:text-unik-gold">
        {b.items.map((li, k) => (
          <li key={k} className="text-[15px] leading-[1.75] text-unik-ink/80">
            {li}
          </li>
        ))}
      </ul>
    );
  }
  return (
    <p key={i} className="mt-4 text-[15px] lg:text-[16px] leading-[1.85] text-unik-ink/85">
      {b.text}
    </p>
  );
}

export default function LegalPage({ variant }) {
  useReveal();
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("vi") ? "vi" : "en";
  const doc =
    variant === "terms"
      ? lang === "vi" ? TERMS_OF_USE_VI : TERMS_OF_USE_EN
      : lang === "vi" ? PRIVACY_POLICY_VI : PRIVACY_POLICY_EN;

  return (
    <div className="min-h-screen bg-white text-unik-ink">
      <SiteNav />
      <PageHero
        eyebrow="Legal"
        title={doc.title}
        accent=""
        bgImage="/assets/unsplash-1583417319070.jpg"
      />
      <section className="relative bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-[820px] px-6 lg:px-10" data-reveal>
          {doc.blocks.map(renderBlock)}
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
